import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { IoMailOutline, IoArrowForward } from 'react-icons/io5';
import axios from 'axios';
import toast, { Toaster } from "react-hot-toast";
import { Link } from 'react-router-dom';
const SubscribeNewsletter = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [appointmentdata, setAppointmentdata] = useState({
    email: '',
    companyId: 65,
    date: new Date().toISOString().split('T')[0],
    time: new Date().toLocaleTimeString(),
  })

  // Animation variants for smoother transitions
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  const handleAppointmentChange = (e) => {
    setAppointmentdata({ ...appointmentdata, [e.target.name]: e.target.value });
  };

  const handleAppointmentSubmit = async () => {

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URI}/appointment/create`, appointmentdata);
      console.log(response.data);
      toast.success("Your appointment has been successfully scheduled.");

      setAppointmentdata({
        email: '',
        companyId: 65,
        date: new Date().toISOString().split('T')[0],
        time: new Date().toLocaleTimeString(),
      });

    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
      toast.error("Failed to create contact");
    }
  };


  return (
    <div className="w-full py-12 md:py-24 px-4 bg-gradient-to-b from-white via-gray-50 to-gray-100 overflow-hidden">
      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8"
      >
        {/* Enhanced Decorative Elements */}
        <div className="flex justify-center mb-8 md:mb-12">
          <motion.div
            className="w-16 md:w-24 h-[1px] bg-gradient-to-r from-transparent via-gray-400 to-transparent"
            initial={{ scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            transition={{ duration: 0.8 }}
          />
        </div>

        {/* Main Content */}
        <div className="text-center space-y-6 md:space-y-8">
          <motion.h2
            variants={itemVariants}
            className="text-2xl sm:text-3xl md:text-4xl font-light tracking-wider text-gray-900 uppercase"
          >
            Freshness Delivered To Your Door
          </motion.h2>

          <motion.p
            variants={itemVariants}
            className="text-sm sm:text-base md:text-lg font-light text-gray-600 max-w-md md:max-w-2xl mx-auto leading-relaxed px-4"
          >
            Join our weekly newsletter for exclusive member-only discounts, premium pantry arrivals, and curated seasonal recipes.
          </motion.p>

          {/* Subscription Form */}
          <motion.div
            variants={itemVariants}
            className="mt-8 md:mt-12 w-full max-w-md sm:max-w-lg md:max-w-2xl mx-auto"
          >
            <div className="relative group">
              <div className="flex items-center p-1.5 bg-white rounded-full shadow-[0_4px_30px_rgba(0,0,0,0.08)] border border-white/50 transition-all duration-300 group-hover:shadow-[0_6px_40px_rgba(0,0,0,0.1)]">
                <div className="hidden sm:flex items-center px-3 md:px-4">
                  <IoMailOutline className="text-gray-400 text-lg md:text-xl transition-colors duration-300 group-hover:text-gray-600" />
                </div>
                <input
                  type="email"
                  value={appointmentdata.email}
                  onChange={handleAppointmentChange}
                  name="email"
                  placeholder="Enter your email address"
                  className="flex-1 py-3 sm:py-4 px-2 sm:px-4 bg-transparent text-gray-800 placeholder-gray-400 focus:outline-none text-sm md:text-base font-light w-full"
                />
                <motion.button
                  onHoverStart={() => setIsHovered(true)}
                  onHoverEnd={() => setIsHovered(false)}
                  whileTap={{ scale: 0.98 }}
                  onClick={handleAppointmentSubmit}
                  className="relative overflow-hidden bg-gradient-to-r from-gray-900 to-black text-white rounded-full py-3 sm:py-4 px-6 sm:px-8 font-light text-xs sm:text-sm md:text-base tracking-wider flex items-center gap-2 hover:gap-3 transition-all duration-300"
                >
                  <span>SUBSCRIBE</span>
                  <IoArrowForward className={`transition-all duration-300 ${isHovered ? 'translate-x-0 opacity-100' : '-translate-x-4 opacity-0'
                    }`} />
                  {/* Premium hover effect */}
                  <motion.div
                    className="absolute inset-0 bg-gradient-to-r from-white/10 to-transparent"
                    initial={{ x: '-100%' }}
                    whileHover={{ x: '100%' }}
                    transition={{ duration: 0.4 }}
                  />
                </motion.button>
              </div>
            </div>

            {/* Additional Information */}
            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.6 }}
              className="text-xs md:text-sm text-gray-500 mt-4 md:mt-6 px-4"
            >
              By subscribing, you agree to our{' '}

              <span className="underline hover:text-gray-700 transition-colors cursor-pointer"><Link
                to="/privacy-policy"
                className="underline hover:text-gray-700 transition-colors cursor-pointer text-orange-600"
              >
                Privacy Policy
              </Link></span> and consent to receive exclusive updates.
            </motion.p>
          </motion.div>

          {/* Enhanced Decorative Elements */}
          <motion.div
            className="pt-12 md:pt-16 flex justify-center gap-2 md:gap-4"
            variants={itemVariants}
          >
            {[0, 1, 2].map((index) => (
              <motion.div
                key={index}
                className="w-1.5 h-1.5 md:w-2 md:h-2 rounded-full bg-gradient-to-b from-gray-400 to-gray-600"
                whileHover={{ scale: 1.2 }}
                transition={{ duration: 0.3 }}
              />
            ))}
          </motion.div>
        </div>
      </motion.div>
      <Toaster />
    </div>
  );
};

export default SubscribeNewsletter;